export const API_AUTH_LOGIN_ROUTE = '/auth/login';
export const API_AUTH_REFRESH_TOKEN_ROUTE = 'auth/refresh_token';
export const API_AUTH_SET_PASSWORD = '/api/user-password';
export const API_AUTH_PASSWORD_CODE_INFO = '/api/user-password-link-code';
export const API_AUTH_RESTORE_PASSWORD = '/api/user-password-link-code/restore';
export const API_AUTH_UPDATE_PASSWORD = '/api/user-password';
export const API_AUTH_VERIFY_TOKEN = '/auth/verify_token';
